import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { checkIsActive, KTIcon, WithChildren } from '../../../../helpers'
import { useLayout } from '../../../core'

type Props = {
  to?: string
  title: string
  icon?: string
  fontIcon?: string
  target?: string
  hasBullet?: boolean
  hasTag?: boolean
  onClick?
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  target,
  hasTag,
  hasBullet = false,
  onClick,
}) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const isActive = to ? checkIsActive(pathname, to) : false;
  const { config } = useLayout()
  const { app } = config

  return (
    <div className='menu-item'>
      {
        to ? (
          <Link className={clsx('menu-link without-sub', { active: isActive })} to={to} target={target}>
            {hasBullet && (
              <span className='menu-bullet'>
                <span className='bullet bullet-dot'></span>
              </span>
            )}
            {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
              <span className='menu-icon'>
                {' '}
                <KTIcon iconName={icon} className='fs-2' />
              </span>
            )}
            {fontIcon && (
              // <div>
              //   <i className={clsx('bi fs-3', fontIcon)}></i>
              //   <span className="badge badge-light-danger">
              //     New
              //   </span>
              // </div>

              <div className="icon-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                <i className={clsx('bi fs-3', fontIcon)}></i>
                {hasTag ? <span className="badge badge-light-danger" style={{ position: 'absolute', top: '-15px', right: '-20px' }}>
                  {t('MENU.NEW')}
                </span> : null}

              </div>

            )}

            <span className='menu-title'>{title}</span>
          </Link>
        ) : (
          <Link className={clsx('menu-link without-sub link', { active: isActive })} to="#" onClick={onClick}>
            {hasBullet && (
              <span className='menu-bullet'>
                <span className='bullet bullet-dot'></span>
              </span>
            )}
            {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
              <span className='menu-icon'>
                {' '}
                <KTIcon iconName={icon} className='fs-2' />
              </span>
            )}
            {fontIcon && (

              <div className="icon-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                <i className={clsx('bi fs-3', fontIcon)}></i>
                {hasTag ? <span className="badge badge-light-danger" style={{ position: 'absolute', top: '-15px', right: '-20px' }}>
                  {t('MENU.NEW')}
                </span> : null}

              </div>

            )}

            <span className='menu-title'>{title}</span>
          </Link>
        )
      }

      {children}
    </div>
  )
}

export { SidebarMenuItem }
